import { render } from "./DialogCanNotReserveBecauseOverLimit.vue?vue&type=template&id=459ec9c7"
import script from "./DialogCanNotReserveBecauseOverLimit.vue?vue&type=script&lang=js"
export * from "./DialogCanNotReserveBecauseOverLimit.vue?vue&type=script&lang=js"
script.render = render

export default script